import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from 'material-ui/CircularProgress';

import PortsAltNamesTable from './Table';

import { getAllPorts } from 'actions/regions/ports';
import styles from 'styles';

class PortsAltNames extends React.Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.getAllPorts();
    }

    render() {
        return (
            <div id='alt-ports' className='table-page'>
                <CircularProgress
                    className={!this.props.isLoaded ? '' : 'hidden'}
                    style={styles.circularProgress}
                />

                <div className={this.props.isLoaded ? '' : 'hidden '}>
                    <div className='container'>
                        <h2>
                            ports alternative names
                        </h2>
                        <PortsAltNamesTable />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            isLogged: state.user.isLogged,
            isLoaded: state.ports.isLoaded,
        };
    },
    dispatch => bindActionCreators({
        getAllPorts,
    },
    dispatch),
)(PortsAltNames);



// WEBPACK FOOTER //
// ./app/components/Regions/PortsAltNames/Page.jsx